import React, { FC, useEffect, useRef } from 'react';
import LinearProgress from '@fv-components/linear-progress';
import FVID from '../FVID';

const css = require('./Login.module.scss');

const LogoutFVID: FC = () => {
    const officeInitialized = useRef(false);

    useEffect(() => {
        const onMessageFromParent = (arg: { message: string; }) => {
            const token = JSON.parse(arg.message).token;

            if (token) {
                FVID.signoutDialog(token);
            } else {
                Office.context.ui.messageParent(JSON.stringify({ status: 'failure', data: 'No token received' }));
            }
        };

        const initializeOfficeHandlers = () => {
            if (officeInitialized.current) return;

            officeInitialized.current = true;

            Office.onReady(() => {
                Office.context.ui.addHandlerAsync(Office.EventType.DialogParentMessageReceived, onMessageFromParent);

                Office.context.ui.messageParent(JSON.stringify({ status: 'dialog_ready_for_token' }));
            });
        };

        const attemptInitialize = (retries = 5, delay = 200) => {
            if (window.Office) {
                initializeOfficeHandlers();
            } else if (retries > 0) {
                setTimeout(() => attemptInitialize(retries - 1, delay), delay);
            } else {
                Office.context.ui.messageParent(JSON.stringify({ status: 'failure', data: 'Office.js not initialized' }));
            }
        };

        attemptInitialize();

    }, []);

    return <>
        <div className={css.container}>
            <div className={css.content} style={{ paddingTop: 50 }}>
                <div className={css.fvidLoginBox} style={{ height: 250 }}>
                    <img
                      alt="Filevine"
                      height="45"
                      src="/assets/fv-logo.svg"
                      style={{ marginLeft: 50, marginBottom: 30 }}
                    />
                    <div style={{ padding: 30 }}>
                        <LinearProgress />
                        <br />
                        Signing out...
                    </div>
                </div>
            </div>
        </div>
    </>;
};

export default LogoutFVID;